import { render, staticRenderFns } from "./LinkingModal.vue?vue&type=template&id=0085efee&"
import script from "./LinkingModal.vue?vue&type=script&lang=js&"
export * from "./LinkingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports